<script>
  //import formatarData from '~js/formatar-data';
  import 'vue-strap/dist/vue-strap-lang';
  import { datepicker } from 'vue-strap';
  import Radio from '~componentes/Radio.vue';
  import formPerguntaServico from '~modulos/form-pergunta/servico';
  import WebRespostasParticipacaoAcionaria from './WebFormRespostasParticipacaoAcionaria.vue';
  import WebRespostasRelacaoContratual from './WebFormRespostasRelacaoContratual.vue';
  import WebRespostasRelacaoFundacao from './WebFormRespostasRelacaoFundacao.vue';
  import WebRespostasEmpresaReferencia from './WebFormRespostasEmpresaReferencia.vue';
  
  export default {
    components: { Radio, datepicker, WebRespostasParticipacaoAcionaria, WebRespostasRelacaoContratual, WebRespostasRelacaoFundacao, WebRespostasEmpresaReferencia },
    props: {
      webFormRespostasFornecedor: {
        type: Array,
        required: true,
      },
      webFormRespostasParticipacaoAcionaria: {
        type: Array,
        required: true,
      },
      webFormRespostasRelacaoContratual: {
        type: Array,
        required: true,
      },
      webFormRespostasEmpresaReferencia: {
        type: Array,
        required: true,
      },
      webFormRespostasRelacaoFundacao: {
        type: Array,
        required: true,
      },
      habilitarDUEDiligence: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        formPerguntas: [],
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      
      exibirPergunta(id) {
        return this.formPerguntas.length > 0
          ? `${id}) ${this.formPerguntas[id - 1].pergunta.replaceAll('VAR_FUNDACAO', this.configuracao.abreviaturaFundacao)}`
          : `${id}) Pergunta ${id}`;
      },
      carregarFormPerguntas() {
        return formPerguntaServico.
          lista()
          .then(formPerguntas => {
            this.formPerguntas = formPerguntas;
          }); 
      },
      validar(valido) {

        if (!valido) throw new Error("validacao com erro");


        return this.habilitarDUEDiligence
          ? this.$validator.validateAll()
          : true;
      },
       validarDadosNaoEnviados(){
        if(!this.$refs.webRespostasEmpresaReferencia.validarDadosNaoEnviados()){
          return false;
        }

        if(!this.$refs.webRespostasParticipacaoAcionaria.validarDadosNaoEnviados()){
          return false;
        }
        
        if(!this.$refs.webRespostasRelacaoContratual.validarDadosNaoEnviados()){
          return false;
        }
        
        if(!this.$refs.webRespostasRelacaoFundacao.validarDadosNaoEnviados()){
          return false;
        }
        return true;
      },
    },
   
    mounted() {
      this.carregarFormPerguntas();

    },
  }
</script>

<template>
  <div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group form-group-resposta" :class="{'required': habilitarDUEDiligence, 'has-error': errors.has('formResposta01a') && errors.has('formResposta01b') &&
             errors.has('formResposta01c')}">
          <label class="control-label" for="pergunta01">{{ exibirPergunta(this.webFormRespostasFornecedor[0].idFormPergunta) }}</label>
          <br />
          <radio v-model="webFormRespostasFornecedor[0].resposta"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 data-vv-name="formResposta01a"
                 v-validate="habilitarDUEDiligence ? 'required' : ''"
                 class="margin-right-10">
            Sim
          </radio>
          <radio v-model="webFormRespostasFornecedor[0].resposta"
                 selected-value="0"
                 type="success"
                 :inline="true"
                 data-vv-name="formResposta01b"
                 v-validate="habilitarDUEDiligence ? 'required' : ''"
                 class="margin-right-10"
                 >
            Não
          </radio>
          <radio v-model="webFormRespostasFornecedor[0].resposta"
                 selected-value="2"
                 type="success"
                 :inline="true"
                 data-vv-name="formResposta01c"
                 v-validate="habilitarDUEDiligence ? 'required' : ''"
                 >
            Não responder
          </radio>
          <p class="text-danger" v-show="errors.has('formResposta01a') && errors.has('formResposta01b') && errors.has('formResposta01c')">Selecione uma opção</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="panel-resposta">
        <web-respostas-participacao-acionaria ref="webRespostasParticipacaoAcionaria"
                                              :webFormRespostasParticipacaoAcionaria="webFormRespostasParticipacaoAcionaria">
        </web-respostas-participacao-acionaria>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group form-group-resposta" :class="{'required': habilitarDUEDiligence, 'has-error': errors.has('formResposta02a') && errors.has('formResposta02b') &&
             errors.has('formResposta02c')}">
          <label class="control-label" for="pergunta02">{{ exibirPergunta(this.webFormRespostasFornecedor[1].idFormPergunta) }}</label>
          <br />
          <radio v-model="webFormRespostasFornecedor[1].resposta"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta02a"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Sim
          </radio>
          <radio v-model="webFormRespostasFornecedor[1].resposta"
                 selected-value="0"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta02b"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não
          </radio>
          <radio v-model="webFormRespostasFornecedor[1].resposta"
                 selected-value="2"
                 type="success"
                 :inline="true"
                 data-vv-name="formResposta02c"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não responder
          </radio>
          <p class="text-danger" v-show="errors.has('formResposta02a') && errors.has('formResposta02b') && errors.has('formResposta02c')">Selecione uma opção</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="panel-resposta">
        <web-respostas-relacao-contratual ref="webRespostasRelacaoContratual"
                                          :webFormRespostasRelacaoContratual="webFormRespostasRelacaoContratual">
        </web-respostas-relacao-contratual>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group" :class="{'required': habilitarDUEDiligence, 'has-error': errors.has('formResposta03a') && errors.has('formResposta03b') &&
             errors.has('formResposta03c')}">
          <label class="control-label" for="pergunta03">{{ exibirPergunta(this.webFormRespostasFornecedor[2].idFormPergunta) }}</label>
          <br />
          <radio v-model="webFormRespostasFornecedor[2].resposta"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta03a"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Sim
          </radio>
          <radio v-model="webFormRespostasFornecedor[2].resposta"
                 selected-value="0"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta03b"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não
          </radio>
          <radio v-model="webFormRespostasFornecedor[2].resposta"
                 selected-value="2"
                 type="success"
                 :inline="true"
                 data-vv-name="formResposta03c"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não responder
          </radio>
          <p class="text-danger" v-show="errors.has('formResposta03a') && errors.has('formResposta03b') && errors.has('formResposta03c')">Selecione uma opção</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="panel-resposta">
        <web-respostas-relacao-fundacao ref="webRespostasRelacaoFundacao"
                                        :webFormRespostasRelacaoFundacao="webFormRespostasRelacaoFundacao">
        </web-respostas-relacao-fundacao>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group" :class="{'required': habilitarDUEDiligence, 'has-error': errors.has('formResposta04a') && errors.has('formResposta04b') &&
             errors.has('formResposta04c')}">
          <label class="control-label" for="pergunta04">{{ exibirPergunta(this.webFormRespostasFornecedor[3].idFormPergunta) }}</label>
          <br />
          <radio v-model="webFormRespostasFornecedor[3].resposta"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta04a"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Sim
          </radio>
          <radio v-model="webFormRespostasFornecedor[3].resposta"
                 selected-value="0"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta04b"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não
          </radio>
          <radio v-model="webFormRespostasFornecedor[3].resposta"
                 selected-value="2"
                 type="success"
                 :inline="true"
                 data-vv-name="formResposta04c"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não responder
          </radio>
          <p class="text-danger" v-show="errors.has('formResposta04a') && errors.has('formResposta04b') && errors.has('formResposta04c')">Selecione uma opção</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group" :class="{'required': habilitarDUEDiligence, 'has-error': errors.has('formResposta05a') && errors.has('formResposta05b') &&
             errors.has('formResposta05c')}">
          <label class="control-label" for="pergunta05">{{ exibirPergunta(this.webFormRespostasFornecedor[4].idFormPergunta) }}</label>
          <br />
          <radio v-model="webFormRespostasFornecedor[4].resposta"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta05a"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Sim
          </radio>
          <radio v-model="webFormRespostasFornecedor[4].resposta"
                 selected-value="0"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta05b"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não
          </radio>
          <radio v-model="webFormRespostasFornecedor[4].resposta"
                 selected-value="2"
                 type="success"
                 :inline="true"
                 data-vv-name="formResposta05c"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não responder
          </radio>
          <p class="text-danger" v-show="errors.has('formResposta05a') && errors.has('formResposta05b') && errors.has('formResposta05c')">Selecione uma opção</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group" :class="{'required': habilitarDUEDiligence, 'has-error': errors.has('formResposta06a') && errors.has('formResposta06b') &&
             errors.has('formResposta06c')}">
          <label class="control-label" for="pergunta06">{{ exibirPergunta(this.webFormRespostasFornecedor[5].idFormPergunta) }}</label>
          <br />
          <radio v-model="webFormRespostasFornecedor[5].resposta"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta06a"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Sim
          </radio>
          <radio v-model="webFormRespostasFornecedor[5].resposta"
                 selected-value="0"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta06b"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não
          </radio>
          <radio v-model="webFormRespostasFornecedor[5].resposta"
                 selected-value="2"
                 type="success"
                 :inline="true"
                 data-vv-name="formResposta06c"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não responder
          </radio>
          <p class="text-danger" v-show="errors.has('formResposta06a') && errors.has('formResposta06b') && errors.has('formResposta06c')">Selecione uma opção</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group" :class="{'required': habilitarDUEDiligence, 'has-error': errors.has('formResposta07a') && errors.has('formResposta07b') &&
             errors.has('formResposta07c')}">
          <label class="control-label" for="pergunta07">{{ exibirPergunta(this.webFormRespostasFornecedor[6].idFormPergunta) }}</label>
          <br />
          <radio v-model="webFormRespostasFornecedor[6].resposta"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta07a"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Sim
          </radio>
          <radio v-model="webFormRespostasFornecedor[6].resposta"
                 selected-value="0"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta07b"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não
          </radio>
          <radio v-model="webFormRespostasFornecedor[6].resposta"
                 selected-value="2"
                 type="success"
                 :inline="true"
                 data-vv-name="formResposta07c"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não responder
          </radio>
          <p class="text-danger" v-show="errors.has('formResposta07a') && errors.has('formResposta07b') && errors.has('formResposta07c')">Selecione uma opção</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group" :class="{'required': habilitarDUEDiligence, 'has-error': errors.has('formResposta08a') && errors.has('formResposta08b') &&
             errors.has('formResposta08c')}">
          <label class="control-label" for="pergunta08">{{ exibirPergunta(this.webFormRespostasFornecedor[7].idFormPergunta) }}</label>
          <br />
          <radio v-model="webFormRespostasFornecedor[7].resposta"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta08a"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Sim
          </radio>
          <radio v-model="webFormRespostasFornecedor[7].resposta"
                 selected-value="0"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta08b"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não
          </radio>
          <radio v-model="webFormRespostasFornecedor[7].resposta"
                 selected-value="2"
                 type="success"
                 :inline="true"
                 data-vv-name="formResposta08c"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não responder
          </radio>
          <p class="text-danger" v-show="errors.has('formResposta08a') && errors.has('formResposta08b') && errors.has('formResposta08c')">Selecione uma opção</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <label class="control-label" for="pergunta09">{{ exibirPergunta(this.webFormRespostasFornecedor[8].idFormPergunta) }}</label>
          <!--<br />
          <radio v-model="webFormRespostasFornecedor[8].resposta"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 class="margin-right-10">
            Sim
          </radio>
          <radio v-model="webFormRespostasFornecedor[8].resposta"
                 selected-value="0"
                 data-vv-name="formResposta09"
                 type="success"
                 :inline="true"
                 class="margin-right-10">
            Não
          </radio>
          <radio v-model="webFormRespostasFornecedor[8].resposta"
                 selected-value="2"
                 type="success"
                 :inline="true">
            Não responder
          </radio>-->
        </div>
      </div>
    </div>

    <div class="row">
      <div class="panel-resposta">
        <web-respostas-empresa-referencia ref="webRespostasEmpresaReferencia"
                                          :webFormRespostasEmpresaReferencia="webFormRespostasEmpresaReferencia">
        </web-respostas-empresa-referencia>
      </div>
    </div>

  </div>
</template>

<style>
  .panel-resposta {
    background: transparent !important;
    padding-left: 10px;
    padding-right: 10px;
    border-width: 1px;
    border-color: lightgray;
    border-radius: 3px;
    border-style: solid;
    margin-left: 15px;
    margin-right: 15px;
    margin-bottom: 15px;
  }

  .form-group-resposta {
    margin-bottom: 0px;
  }

</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/web-fornecedor/componentes/compartilhado/FormDueDiligence.vue